export const SET_LOGIN_USERNAME = 'SET_LOGIN_USERNAME';
export function setLoginUsername(value) {
    return {
        type: SET_LOGIN_USERNAME,
        payload: {
            username: value
        }
    };
}
